import React from 'react';
import { Button } from 'antd';

import DocumentsContainer from '@totem/components/documents/report/documentsContainer';
import DocumentSearchInput from '@totem/components/documents/report/documentSearchInput';
import { DocumentReference } from '@totem/components/documents/types';
import DocumentLinkSubmitButton from '@totem/components/documents/upload/documentLinkSubmitButton';
import DocumentsLinkTable from '@totem/components/documents/upload/documentsLinkTable';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';

type Props = {
  onClose: (refresh: boolean) => void;
  reference: DocumentReference;
};

const DocumentsLinkPanel = ({ onClose, reference }: Props) => {
  return (
    <DocumentsContainer>
      <DocumentSearchInput />
      <br />
      <br />
      <DocumentsLinkTable />
      <ModalFooter>
        <Button onClick={() => onClose(false)}>Close</Button>
        <DocumentLinkSubmitButton onClose={onClose} reference={reference} />
      </ModalFooter>
    </DocumentsContainer>
  );
};

export default DocumentsLinkPanel;
